define('util/InsufficientPermissionsError',[],function () {
    'use strict';
    function InsufficientPermissionsError(requiredPermissions) {
        this.message = 'Insufficient permissions';
        this.requiredPermissions = requiredPermissions;
    }
    InsufficientPermissionsError.prototype = Object.create(Error.prototype);
    InsufficientPermissionsError.prototype.constructor = InsufficientPermissionsError;
    return InsufficientPermissionsError;
});
